<template>
  <div id="wrapper" class="noheader">
    <div class="content">
      <div class="caption">
        <div class="inner">
          <span></span>
          <p>木生婦幼診所</p>
          <span></span>
        </div>
        <a
          v-if="$store.state.from === '/FeedBack'"
          @click="backHome"
          class="arr"
          ><div class="inner"></div
        ></a>
      </div>
      <div class="surveyBox">
        <div class="title">
          <h2 style="text-align: center;">
            顧客滿意度調查
          </h2>
        </div>
        <p style="color: #999999; text-align: justify;">
          親愛的患者您好:
          <br />
          本院為提供更友善專業的醫療服務環境，懇請您利用幾分鐘的時間，填寫這份問卷。為保護您的權益，本問卷將由專人處理，問卷內容均予保密。
          <br />
          您的反饋是我們進步的動力，若您需要即刻地改善，請寫下姓名與電話，並請提供建議或改善事項，我們會盡快處理，感謝您的指教與支持。
        </p>
        <br />
        <div class="formBox">
          <form action="javascript:void(0);">
            <h3 style="text-align: center;">
              就診背景
            </h3>
            <br />
            <p style="display:inline;">
              請問您是初次來訪本院就診？
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <br />
            <select v-model="survey['初次來訪']">
              <option value="">請選擇下列選項</option>
              <option value="是">是</option>
              <option value="否">否</option>
            </select>
            <p>
              請問您今天是如何掛到號？
            </p>
            <select v-model="survey['掛號方式']">
              <option value="">請選擇下列選項</option>
              <option value="網路掛號">網路掛號</option>
              <option value="APP掛號">APP掛號</option>
              <option value="診間醫師預約">診間醫師預約</option>
              <option value="出院護理站預約">出院護理站預約</option>
              <option value="人工電話預約">人工電話預約</option>
              <option value="當日現場掛號">當日現場掛號</option>
            </select>

            <p style="display:inline;">
              請問您(就醫者)今日看診科別為
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <select v-model="survey['看診科別']">
              <option value="">請選擇下列選項</option>
              <option value="婦科">婦科</option>
              <option value="產科">產科</option>
              <option value="影像醫學">影像醫學</option>
              <option value="小兒門診">小兒門診</option>
            </select>
            <br />
            <div>
              <p style="display:inline;">
                請問您(就醫者)今日看診醫師為
              </p>
              <p style="color: red; display:inline-block;">（必填）</p>
            </div>
            <br />
            <input
              v-model="survey['看診醫師']"
              type="text"
              class="inputBox line"
            />
            <h3 style="text-align: center;">
              診所醫療設施與服務
            </h3>
            <br />
            <div
              v-for="(questionSet, number) in satisfactoinQuestion"
              :key="number"
            >
              <b>
                {{ satisfactoinTitle[number] }}
              </b>
              <b style="color: red;" v-if="number === 3">（必填）</b>
              <br />
              <br />
              <div v-for="question in questionSet" :key="question">
                <p style="color: #999999;">
                  {{ question }}
                </p>
                <br />
                <select v-model="survey[question]">
                  <option value="">請選擇下列選項</option>
                  <option value="滿意">滿意</option>
                  <option value="普通">普通</option>
                  <option value="不滿意">不滿意</option>
                  <option value="沒接觸">沒接觸</option>
                </select>
              </div>
            </div>
            <!-- 總結 -->
            <h3 style="text-align: center;">
              總結
            </h3>
            <br />
            <p>
              請您為本次就醫總體滿意度打一個分數
            </p>
            <br />
            <select v-model="survey['滿意度分數']">
              <option value="">請選擇下列選項</option>
              <option value="90以上">90以上</option>
              <option value="80-90分">80-90分</option>
              <option value="70-79分">70-79分</option>
              <option value="60分以下">60分以下</option>
            </select>
            <br />
            <p>
              整體而言，這次門診的治療結果跟您預期中的情況相比是
            </p>
            <br />
            <select v-model="survey['預期中的情況相比']">
              <option value="">請選擇下列選項</option>
              <option value="有進步">有進步</option>
              <option value="差不多">差不多</option>
              <option value="比較差">比較差</option>
              <option value="差很多">差很多</option>
            </select>
            <br />
            <p>
              請問您是否願意推薦木生診所給您的親友？
            </p>
            <br />
            <select v-model="survey['是否推薦']">
              <option value="">請選擇下列選項</option>
              <option value="非常願意">非常願意</option>
              <option value="願意">願意</option>
              <option value="普通">普通</option>
              <option value="不願意">不願意</option>
              <option value="非常不願意">非常不願意</option>
            </select>
            <br />

            <p style="display:inline;">
              您覺得木生診所的門診整體服務，表現最讓您滿意的是？
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <br />
            <div class="checksBox">
              <label class="checkMC"
                ><input
                  v-model="survey['滿意的地方']['各方面都很好']"
                  type="checkbox"
                />
                <div class="box"></div>
                各方面都很好</label
              >
              <br />
              <label class="checkMC"
                ><input
                  v-model="survey['滿意的地方']['診所環境設施滿意']"
                  type="checkbox"
                />
                <div class="box"></div>
                診所環境設施</label
              >
              <br />
              <label class="checkMC"
                ><input
                  v-model="survey['滿意的地方']['等候時間滿意']"
                  type="checkbox"
                />
                <div class="box"></div>
                等候時間</label
              >
              <br />
              <label class="checkMC"
                ><input
                  v-model="survey['滿意的地方']['櫃檯人員的服務態度滿意']"
                  type="checkbox"
                />
                <div class="box"></div>
                櫃檯人員的服務態度</label
              >
              <br />
              <label class="checkMC"
                ><input
                  v-model="survey['滿意的地方']['護理人員的專業度滿意']"
                  type="checkbox"
                />
                <div class="box"></div>
                護理人員的專業度</label
              >
              <br />
              <label class="checkMC"
                ><input
                  v-model="survey['滿意的地方']['病人安全及醫療過程滿意']"
                  type="checkbox"
                />
                <div class="box"></div>
                病人安全及醫療過程</label
              >
              <br />
              <label class="checkMC"
                ><input
                  v-model="survey['滿意的地方']['滿意的其他']"
                  type="checkbox"
                />
                <div class="box"></div>
                其他 </label
              ><input
                v-model="survey['滿意的地方']['滿意的其他內容']"
                type="text"
                class="inputBox line"
              />
            </div>
            <br />
            <p>
              如您願意嘉獎某位工作人員，請填下他的姓名
            </p>
            <br />
            <input
              v-model="survey['嘉獎工作人員姓名']"
              type="text"
              placeholder="姓名"
              class="inputBox line"
            />
            <br />
            <br />

            <p style="display:inline;">
              您覺得木生診所的門診整體服務，最需要改善的是？
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <br />
            <div class="checksBox">
              <label class="checkMC"
                ><input
                  v-model="survey['須改善的地方']['各方面都亟需改善']"
                  type="checkbox"
                />
                <div class="box"></div>
                各方面都亟需改善</label
              >
              <br />
              <label class="checkMC"
                ><input
                  v-model="survey['須改善的地方']['診所環境設施須改善']"
                  type="checkbox"
                />
                <div class="box"></div>
                診所環境設施</label
              >
              <br />
              <label class="checkMC"
                ><input
                  v-model="survey['須改善的地方']['等候時間須改善']"
                  type="checkbox"
                />
                <div class="box"></div>
                等候時間</label
              >
              <br />
              <label class="checkMC"
                ><input
                  v-model="survey['須改善的地方']['櫃檯人員的服務態度須改善']"
                  type="checkbox"
                />
                <div class="box"></div>
                櫃檯人員的服務態度</label
              >
              <br />
              <label class="checkMC"
                ><input
                  v-model="survey['須改善的地方']['護理人員的專業度須改善']"
                  type="checkbox"
                />
                <div class="box"></div>
                護理人員的專業度</label
              >
              <br />
              <label class="checkMC"
                ><input
                  v-model="survey['須改善的地方']['病人安全及醫療過程須改善']"
                  type="checkbox"
                />
                <div class="box"></div>
                病人安全及醫療過程</label
              >
              <br />
              <label class="checkMC"
                ><input
                  v-model="survey['須改善的地方']['須改善的其他']"
                  type="checkbox"
                />
                <div class="box"></div>
                其他 </label
              ><input
                v-model="survey['須改善的地方']['須改善的其他內容']"
                type="text"
                class="inputBox line"
              />
            </div>
            <br />
            <p>呈上，如有不滿意的地方，歡迎給我們建議的做法。</p>
            <input
              v-model="survey['建議做法']"
              type="text"
              class="inputBox line"
            />
            <br />
            <p>如您希望投訴某位工作人員，請填下他的姓名</p>
            <br />
            <input
              v-model="survey['被投訴員工姓名']"
              type="text"
              class="inputBox line"
            />
            <br />
            <p>
              不滿意之描述
            </p>
            <br />
            <textarea
              v-model="survey['不滿意描述']"
              placeholder="訊息輸入"
            ></textarea>
            <br />
            <p>
              對於上述事項，如同意我們與您進一步聯絡，請留下聯絡方式
              請留下您的姓名與聯絡電話，專人會儘快與您聯絡，謝謝。
            </p>
            <br />
            <input
              v-model="survey['聯絡方式']"
              type="text"
              class="inputBox line"
            />

            <p style="display:inline;">
              您的就診日期為
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <br />
            <input
              v-model="survey['就診日期']"
              type="date"
              class="inputBox line"
            />
            <br />
            <p style="display:inline;">
              診別
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <br />
            <select v-model="survey['診別']">
              <option value="">請選擇下列選項</option>
              <option value="上午診">上午診</option>
              <option value="下午診">下午診</option>
              <option value="夜診">夜診</option>
            </select>
            <br />
            <p style="display:inline;">
              本份問卷是由
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <br />
            <select v-model="survey['填寫人']">
              <option value="">請選擇下列選項</option>
              <option value="患者本人填寫">患者本人填寫</option>
              <option value="親友帶填">親友帶填</option>
            </select>
            <p style="color: #999999; text-align: justify;">
              問卷到此告一段落 : ) 再次感謝您的耐心分享，
              您的批評與指教是我們最寶貴的禮物。<br />
              木生全體醫護人員，在此向您鞠躬致謝。<br />
              祝願您擁有美好的一天！
            </p>
            <br />
            <input
              @click.prevent="submitForm"
              type="submit"
              class="submitBtn"
              value="確認送出"
            />
          </form>
        </div>
      </div>
    </div>
  </div>
  <modal v-if="modal.display" @close="closeModal">
    <template #header>{{ modal.header }}</template>
    <template #body>{{ modal.body }}</template>
  </modal>
</template>
<script>
import { reactive, ref } from "vue";
import { useRouter } from "vue-router";
const returnRouter = () => {
  const router = useRouter();

  const goTo = destination => {
    router.replace(destination);
  };
  return {
    goTo
  };
};
import store from "../../store/index.js";
import axios from "axios";
export default {
  setup() {
    const { goTo } = returnRouter();
    const survey = ref({
      滿意的地方: {},
      須改善的地方: {}
    });
    const modal = reactive({});
    const satisfactoinTitle = reactive([
      "診所環境與設施",
      "看診流程",
      "主治醫師看診服務",
      "工作人員服務"
    ]);
    const satisfactoinQuestion = ref([
      [
        "空調冷暖適中",
        "指示牌標示清楚",
        "診間器具清潔度",
        "洗手間清潔程度",
        "門診環境清潔度"
      ],
      [
        "掛號等候時間",
        "看診等候時間",
        "醫師看診時間",
        "檢驗等候時間",
        "等候超音波檢查的時間",
        "等候領藥批價的時間"
      ],
      [
        "預約看診時間與實際看診時間是否相符",
        "您認為醫師的診療是否有處理及改善您的症狀",
        "醫師用您能了解的方式清楚地回答問題",
        "您是否信賴您的醫師呢",
        "接受診療時保有自己的隱私"
      ],
      [
        "總機人員電話中的應答態度",
        "護理人員用您能了解的方式清楚地回答問題",
        "檢驗人員的服務態度",
        "超音波檢查人員的服務態度",
        "掛號與批價人員的服務態度",
        "領藥時清楚說明用藥資訊",
        "藥袋上標示的內容清楚易懂"
      ]
    ]);

    function submitForm() {
      // let question3Pass = true;
      // satisfactoinQuestion.value[3].forEach(question => {
      //   question3Pass = question3Pass && survey.value[question];
      // });

      // let satisfiedPass = Object.keys(survey.value.滿意的地方).length && true;
      // let improvmentPass =
      //   Object.keys(survey.value.須改善的地方).length && true;

      // for (let prop in survey.value.滿意的地方) {
      //   satisfiedPass = satisfiedPass && survey.value.滿意的地方[prop];
      // }
      // for (let prop in survey.value.須改善的地方) {
      //   improvmentPass = improvmentPass && survey.value.須改善的地方[prop];
      // }

      // // [檢查項目,錯誤訊息]
      // const checkingList = [
      //   [survey.value.初次來訪, "是否初次來訪"],
      //   [survey.value.看診科別, "看診科別"],
      //   [question3Pass, "工作人員服務"],
      //   [satisfiedPass, "滿意的地方"],
      //   [improvmentPass, "須改善的地方"],
      //   [survey.value.就診日期, "就診日期"],
      //   [survey.value.診別, "診別"],
      //   [survey.value.填寫人, "填寫人"]
      // ];
      // // 檢查是否通過
      // let passChecking = true;
      // checkingList.forEach(item => {
      //   passChecking = passChecking && item[0];
      // });

      // // guard
      // if (!passChecking) {
      //   let bodyMessage = "請補足以下欄位：\n";
      //   checkingList.forEach(item => {
      //     if (item[0] === undefined || item[0] === false || item[0] === 0) {
      //       bodyMessage = bodyMessage + item[1] + "\n";
      //     }
      //   });
      //   modal.display = true;
      //   (modal.header = "必填欄位缺失"), (modal.body = bodyMessage);

      //   return;
      // }

      axios
        .post("/api/mobile/SurveyForm", {
          action: "set",
          jwt: store.state.member.jwt,
          type: "門診部",
          data: survey.value
        })
        .then(response => {
          if (response.data.code === "success") {
            Object.assign(modal, {
              type: "success",
              display: true,
              header: "表單填寫成功",
              body: "感謝您的耐心填寫。"
            });
            return;
          }
          Object.assign(modal, {
            type: "fail",
            display: true,
            header: "填寫異常",
            body: response.data.message
          });
        })
        .catch(error => {
          Object.assign(modal, {
            type: "fail",
            display: true,
            header: "網路連線異常",
            body: error.message
          });
        });
    }

    function backHome() {
      goTo("/FeedBack");
    }

    function closeModal() {
      if (modal.type === "success" && store.state.from === "/FeedBack") {
        goTo("/Feedback");
        return;
      }
      modal.display = false;
    }

    return {
      backHome,
      survey,
      satisfactoinQuestion,
      submitForm,
      satisfactoinTitle,
      modal,
      closeModal
    };
  }
};
</script>
